import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// Estilização
import * as S from "./styles"; // Crie um styles.js com a estrutura base
import Header from "../../components/Header";
import Footer from "../../components/Footer";

// Componente do menu lateral
const SidebarMenu = ({ navigate, rotaAtiva }) => {
  const itensMenu = [
     { label: "Home", path: "/home" },
    // { label: "Roteiro Base", path: "/AtendimentoBase" },
    // { label: "Agendar Roteiro", path: "/Atendimento" },
    // { label: "Quadro Roteiro", path: "/Quadrodeatendimentos" },
    
  ];

  return (
    <>
      {itensMenu.map((item, index) => (
        <S.MenuButton
          key={index}
          onClick={() => navigate(item.path)}
          active={rotaAtiva === item.path}
        >
          {item.label}
        </S.MenuButton>
      ))}
    </>
  );
};

const PainelMetricas = () => {
  const navigate = useNavigate();

  return (
    <S.Wrapper>
       <S.Sidebar>
              <S.SidebarTitle>
                <FaMapMarkerAlt style={{ marginRight: '8px' }} />
                Financeiro
              </S.SidebarTitle>
              <SidebarMenu navigate={navigate} rotaAtiva="/home" />
            </S.Sidebar>

      <S.MainContent>
        <Header />
        

        <S.DashboardPlaceholder>
          <h1>Em breve</h1>
          <p>Modulo Financeiro</p>
        </S.DashboardPlaceholder>

        
      </S.MainContent>
      <Footer />
    </S.Wrapper>
  );
};

export default PainelMetricas;
